import React from 'react';
import { FaPhoneAlt, FaClock } from 'react-icons/fa';

const HeaderTop = () => {
    return (
        <div className="header-top pt-15 pb-15 bg-1">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                        <div className="header-info">
                            <ul>
                                <li>
                                    <FaPhoneAlt /> Call on :
                                    <a href="/"> (613) 879 1719</a>
                                </li>
                                <li>
                                    <FaClock /> Open Hours : Mon - Fri 08:00AM - 10:00PM
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                        <div className="header-social text-center text-xl-end text-lg-end">
                            <a href="https://www.facebook.com/profile.php?id=61560320402071">Facebook</a>
                            
                            <a href="https://www.instagram.com/bright_sun_cleaning_and_garden/">Instagram</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTop;